// ADSB data is an array of aircraft like this:
// {
//   icao_address: '7C80AE'
//   time: 1705376735194
//   latitude: -34.054451
//   longitude: 151.274752
//   altitude_mm: 1531620
//   heading_cd: 11646
//   horizontal_velocity_cms: 13375
//   vertical_velocity_cms:-812
//   emitter_type: 0
// }
// EFB data is an array of aircraft like this:
// {
//   id: 'HQ0kE'
//   name: 'VH-TKF'
//   time: 1771301085226
//   latitude: -33.111566
//   longitude: 148.085745
//   altitude_mm: 1066800
//   heading_cd: 3700
//   horizontal_velocity_cms: 4733
// }

export const buildCzmlPackage = (rawList, pointColor = [255, 20, 20, 220], pathColor = [255, 255, 0, 188]) => {
  const currentTime = new Date()
  const currentTimeIso = currentTime.toISOString()

  // 1 hour ago
  const startTimeIso = new Date(currentTime.getTime() - 60 * 60 * 1000).toISOString()
  // 3 hours from now
  const endTimeIso = new Date(currentTime.getTime() + 3 * 60 * 60 * 1000).toISOString()

  const documentInterval = startTimeIso + '/' + endTimeIso

  const aircraftList = rawList.map((aircraft) => {
    const id = aircraft.id || aircraft.icao_address
    const name = aircraft.name || aircraft.icao_address
    const lat = aircraft.latitude
    const lon = aircraft.longitude
    const alt = aircraft.altitude_mm / 1000
    const timestamp = aircraft.time
    const horVelocity = aircraft.horizontal_velocity_cms / 100
    const verVelocity = (aircraft.vertical_velocity_cms ?? 0) / 100
    const heading = aircraft.heading_cd / 100

    const description = getAircraftDescription(name, lat, lon, alt, heading, horVelocity)

    const aircraftTime = new Date(timestamp)
    const aircraftTimeIso = aircraftTime.toISOString()

    // 10 min ago.
    const startTimeIso = new Date(aircraftTime.getTime() - 10 * 60 * 1000).toISOString()

    // 1 min from now
    const endTimeIso = new Date(aircraftTime.getTime() + 60 * 1000).toISOString()

    const itemAvailability = startTimeIso + '/' + endTimeIso

    const props = {
      horVelocity,
      verVelocity,
      altitude: alt,
      heading,
      lon,
      lat
    }
    const result = {
      id,
      name,
      properties: props,
      availability: itemAvailability,
      description,
      path: {
        material: {
          solidColor: {
            color: {
              rgba: pathColor
            }
          }
        },
        width: 2,
        leadTime: 30,
        trailTime: 120
      },
      // Position is an interpolatable property: https://github.com/AnalyticalGraphicsInc/czml-writer/wiki/InterpolatableProperty
      position: {
        forwardExtrapolationType: 'HOLD',
        interpolationAlgorithm: 'LAGRANGE',
        interpolationDegree: 2,
        epoch: aircraftTimeIso,
        cartographicDegrees: [aircraftTimeIso, lon, lat, alt]
      },
      point: {
        color: {
          rgba: pointColor
        },
        pixelSize: 16,
        scaleByDistance: {
          nearFarScalar: [2000, 1, 20000, 0.4]
        }
      }
    }

    return result
  })

  // Construct the CZML object for the path
  return [
    {
      id: 'document',
      version: '1.0',
      clock: {
        interval: documentInterval,
        currentTime: currentTimeIso,
        multiplier: 1,
        clockRange: Cesium.ClockRange.UNBOUNDED,
        clockStep: Cesium.ClockStep.SYSTEM_CLOCK_MULTIPLIER
      }
    },
    ...aircraftList
  ]
}

const getAircraftDescription = (name, lat, lon, alt, heading, horVelocity) =>
  `
    <table class="cesium-infoBox-defaultTable">
      <tbody>
        <tr>
          <th>Name</th>
          <td>${name}</td>
        </tr>
        <tr>
          <th>Latitude</th>
          <td>${lat}</td>
        </tr>
        <tr>
          <th>Longitude</th>
          <td>${lon}</td>
        </tr>
        <tr>
          <th>Altitude</th>
          <td>${alt} m</td>
        </tr>
        <tr>
          <th>Heading</th>
          <td>${heading} deg</td>
        </tr>
        <tr>
          <th>Horizontal Velocity</th>
          <td>${horVelocity} m/s</td>
        </tr>
      </tbody>
    </table>
  `
